<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title"> {{'wizzard.changeCredit' | translate}}</span>
      <button mat-button class="mat-icon-button"
              (click)="dialogRef.close()"
              aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="m-0">
    <div style="display: flex; align-items: center">
      <mat-form-field style="width: 50%; padding:10px">
        <mat-select placeholder="Select Event Level" [(ngModel)]="selected">
          @for (item of data.eventType; track item.id) {
            <mat-option [value]="item.id">
              {{item.name}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field style="width: 40%; padding:10px">
        <input matInput placeholder="Credit" [(ngModel)]="credit" type="number" min="1">
      </mat-form-field>
      <button mat-icon-button>
        <mat-icon (click)="addNew(selected, credit)" aria-label="Example icon-button with a heart icon">add</mat-icon>
      </button>
    </div>
    @for (item of transferData; track item; let i = $index) {
      <h3 style="width: 80%; display: inline-block"> {{item.name + ' - ' + item.credit + ' credits'}}</h3>@if (item.id) {
        <i
          style="vertical-align: middle; cursor: pointer" (click)="removeFromTranfer(i)" class="material-icons">
          remove
        </i>
      }
    }
  </div>
</div>


